var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('resource',{attrs:{"resource":"giftCategory","resourceName":"Geschenkkategorie","attributes":[
      {
        name: 'name',
        label: 'Name'
      },
      {
        name: 'active',
        label: 'Aktiv',
        type: 'CheckboxSelector',
        value: false
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Geschenkkategorie erstellen")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }